import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5400ca41&class=full-heigth&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5400ca41')) {
      api.createRecord('5400ca41', component.options)
    } else {
      api.reload('5400ca41', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5400ca41&class=full-heigth&", function () {
      api.rerender('5400ca41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/aiFunctionManage/aiFunctionCommentator/index.vue"
export default component.exports